import { TickerAnimSpeedEnum } from "../types";

const TICKER_SPEEDS = {
  [TickerAnimSpeedEnum.Fast]: 500,
  [TickerAnimSpeedEnum.Medium]: 1000,
  [TickerAnimSpeedEnum.Slow]: 1500,
} as const;

export const getTickerAnimSpeed = (speed: TickerAnimSpeedEnum): number => {
  return TICKER_SPEEDS[speed] ?? TICKER_SPEEDS[TickerAnimSpeedEnum.Medium];
};
